import { Routes } from '@angular/router';
import { InputDetailComponent } from './input-detail/input-detail.component';
import { InputReviewComponent } from './input-review/input-review.component';
import { InputVideoComponent } from './input-video/input-video.component';

/**
 * Community inputs, under `/contributions/inputs` beside the member's other work — the Ideas
 * plan, decision 3.32. The self-service list will later be `/contributions/inputs` itself.
 */
export const communityInputRoutes: Routes = [
  // No list yet: self-service browsing is a later route over the same inputs.
  { path: '', pathMatch: 'full', redirectTo: '/contributions' },
  {
    path: ':slug',
    data: { label: 'Input', translationKey: null, labelSource: 'titleService' },
    children: [
      { path: '', component: InputDetailComponent },
      {
        path: 'review',
        component: InputReviewComponent,
        data: { label: 'Your review', translationKey: 'inputs.your_review', translationScope: 'inputs', labelSource: null },
      },
      {
        path: 'video',
        component: InputVideoComponent,
        data: { label: 'Your video', translationKey: 'inputs.your_video', translationScope: 'inputs', labelSource: null },
      },
    ],
  },
];
